import _compact from 'lodash/compact';
import _uniq from 'lodash/uniq';
import getAllUniqueRoots from './getAllUniqueRoots';
import getTreeArrayRepresentation from './getTreeArrayRepresentation';
import {MapCardConnector} from 'common/src/components/CLCardsMap/Canvas/Canvas.types';
import {Nodes} from 'common/src/modules/nodes/nodes.types';

export default function inferAllHiddenNodes(
  hiddenNodeConnectors: MapCardConnector[],
  nodes: Nodes,
) {
  if (!hiddenNodeConnectors.length) return [];

  /**
   * Steps:
   * 1. get uniqueRoots.
   * 2. get visibleNodeIds.
   * 3. make a deep copy of every node, and remove the outputs of the connectorsToHide.
   * 4. get visibleNodeIds.
   * 5. the differences between visibleNodeIds from (3) and visibleNodeIds from (4) are the hiddenNodeIds.
   * 6. return hiddenNodeIds.
   */

  const arrayRepresentationOfTree = getTreeArrayRepresentation(nodes); //every index is a nodeId every array is the output

  function getVisibleNodeIds(rootNodes: number[]): number[] {
    const visibleNodeIds: number[] = [];

    rootNodes.forEach((node) => {
      visibleNodeIds.push(node);

      if (arrayRepresentationOfTree[node]) {
        visibleNodeIds.push(...getVisibleNodeIds(arrayRepresentationOfTree[node]));
      }
    });

    return _uniq(_compact(visibleNodeIds));
  }

  const uniqueRootsFromRecursion: number[] = getAllUniqueRoots(nodes);
  const originallyVisibleNodeIds = getVisibleNodeIds(uniqueRootsFromRecursion);

  //changing connections
  hiddenNodeConnectors.forEach((hiddenConnector) => {
    arrayRepresentationOfTree[hiddenConnector.outputNodeId][
      arrayRepresentationOfTree[hiddenConnector.outputNodeId].indexOf(hiddenConnector.inputNodeId)
    ] = null;
  });

  const newVisibleNodeIds = getVisibleNodeIds(uniqueRootsFromRecursion);

  return _uniq(
    _compact(
      originallyVisibleNodeIds.filter(
        (visibleNodeId) => !newVisibleNodeIds.includes(visibleNodeId),
      ),
    ),
  );
}
